import {array, number} from "../general-purpose-parsers";

export const parsePlotterUserInput = array(number);
